import React from "react";

/**
 * Progress header for logged-in vendors creating an additional ad (no password step).
 */
const VendorNewListingStepIndicator = ({
  category,
  stepPayment,
  stepSignature,
  hideSignatureStep = false,
}) => (
  <div className="bg-light rounded-3 p-3 mb-3">
    <div className="steps pt-4 pb-1">
      <div
        className={
          category && !stepPayment && !stepSignature ? "step active" : ""
        }
      >
        <div className="step-progress">
          <span className="step-progress-start"></span>
          <span className="step-progress-end"></span>
          <span className="step-number">1</span>
        </div>
        <div className="step-label">Information</div>
      </div>
      <div
        className={
          stepPayment && (!hideSignatureStep || !stepSignature)
            ? "step active"
            : ""
        }
      >
        <div className="step-progress">
          <span className="step-progress-start"></span>
          <span className="step-progress-end"></span>
          <span className="step-number">2</span>
        </div>
        <div className="step-label">Payment</div>
      </div>
      {!hideSignatureStep ? (
        <div className={stepSignature ? "step active" : ""}>
          <div className="step-progress">
            <span className="step-progress-start"></span>
            <span className="step-progress-end"></span>
            <span className="step-number">3</span>
          </div>
          <div className="step-label">Acknowledgment & Signature</div>
        </div>
      ) : (
        <div className="step text-muted">
          <div className="step-progress">
            <span className="step-progress-start"></span>
            <span className="step-progress-end"></span>
            <span className="step-number">✓</span>
          </div>
          <div className="step-label small">Agreement on file</div>
        </div>
      )}
    </div>
  </div>
);

export default VendorNewListingStepIndicator;
